import { useEffect, useState } from "react";
import { UsersService } from "../services/users-service";
import { IUserInfo } from "../users-service-types";
import { getUserByLogin } from "shared/lib/utils/suggest-staff-api";
import { IntranetSuggestResponse } from "shared/lib/utils/intranetSearch/models/intranet-search";

export const useUserInfo = () => {
    const [user, setUser] = useState<IUserInfo>();

    useEffect(() => {
        (async () => {
            const userService = new UsersService();
            let userInfo: IUserInfo | undefined = await userService.loadUserInfo();
            setUser(userInfo);
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
        })();
    }, []);

    // получить Имя Фамилия ru и en пользователя в начале сеанса,
    // используется при создании и копировании формы - для пользователя создаётся роль ADMIN формы
    const login = user?.login;
    useEffect(() => {

        if( !login ) return;
        if( user?.isExternal ) return;

        getUserByLogin(login, "ru").then(res => {
            if( !user ) return;
            user.userName = getName( res );
            setUser(user);
            localStorage.setItem('userInfo', JSON.stringify(user));
        });

        getUserByLogin(login, "en").then(res => {
            if( !user ) return;
            user.userNameEn = getName( res );
            setUser(user);
            localStorage.setItem('userInfo', JSON.stringify(user));
        });

    }, [login]);

    const getName = (res: IntranetSuggestResponse | undefined) => {
        let name;
        if (res && res.people && res.people.result) {
            const value = res.people.result.find((r) => r.login === login);
            if (value) {
                name = `${value.name.first} ${value.name.last}`
            }
        }
        return name;
    };

    return user;
};
